/* eslint-disable no-nested-ternary */
import { AppSyncFarm } from 'common/models/farm';
import React from 'react';
import { NumberUtils } from 'utils/numberUtils';
import { FarmUtils } from 'utils/farmUtils';
import FormatNumber from '../FormatPercent/FormatNumber';
import SpinnerContainer from '../SpinnerContainer';
import { FarmUserInfo } from 'common/models/token';
import { Nullable, Optional } from 'common/models/optional';

type Props = {
  farm: Nullable<AppSyncFarm>;
  farmUserInfo: Optional<FarmUserInfo>;
  availableLP: bigint;
  availableLPUSD: number;
  isLoading: boolean;
  isVaultFarm?: boolean;
  amount: string;
  amountUSD?: number;
  type?: string;
  innerLiquidityPercentage: number;
};

const WithdrawingAmounts: React.FC<Props> = (props) => {
  const farm = props.farm;
  const baseToken = FarmUtils.getBaseToken(farm);
  const baseUserToken =
    props.farmUserInfo &&
    props.farmUserInfo.tokens.filter((t) => t.name === baseToken?.name)[0];
  const memberToken = FarmUtils.getRewardToken(farm);
  const memberUserToken =
    props.farmUserInfo &&
    props.farmUserInfo.tokens.filter((t) => t.name === memberToken?.name)[0];
  const totalAmount = props.farmUserInfo
    ? (props.farmUserInfo.totalLPUSD * props.innerLiquidityPercentage) / 100
    : 0;
  const baseTokenAmount = baseUserToken
    ? (baseUserToken.totalAmountUSD * props.innerLiquidityPercentage) / 100
    : 0;
  const memberTokenAmount = memberUserToken
    ? (memberUserToken.totalAmountUSD * props.innerLiquidityPercentage) / 100
    : 0;

  const baseTokenDisplayName = baseToken?.displayName === 'ETHC' ? 'ETH' : baseToken?.displayName;
  const memberTokenDisplayName = memberToken?.displayName === 'ETHC' ? 'ETH' : memberToken?.displayName;

  const totalLpBaseTokens = (
    <FormatNumber
      value={FarmUtils.amountInTokens(totalAmount, baseToken)}
      postfix={` ${baseTokenDisplayName}`}
      isLoading={false}
      displayDecimals={NumberUtils.determineDecimals(
        FarmUtils.amountInTokens(props.farmUserInfo?.totalLPUSD, baseToken)
      )}
      useNumbro={true}
    />
  );

  const baseTokenAmountBaseTokens = (
    <FormatNumber
      value={FarmUtils.amountInTokens(baseTokenAmount, baseToken)}
      postfix={` ${baseTokenDisplayName}`}
      isLoading={false}
      displayDecimals={NumberUtils.determineDecimals(
        FarmUtils.amountInTokens(baseUserToken?.totalAmountUSD, baseToken)
      )}
      useNumbro={true}
    />
  );

  const memberTokenAmountBaseTokens = (
    <FormatNumber
      value={FarmUtils.amountInTokens(memberTokenAmount, memberToken)}
      postfix={` ${memberTokenDisplayName}`}
      isLoading={false}
      displayDecimals={NumberUtils.determineDecimals(
        FarmUtils.amountInTokens(memberUserToken?.totalAmountUSD, memberToken)
      )}
      useNumbro={true}
    />
  );

  return (
    <div className="content-inner-bg-color p-3 mt-3 primary-text-color">
      {props.farmUserInfo?.totalLPUSD && props.farmUserInfo?.totalLPUSD > 0 && (
        <>
          <div className="flex flex-row justify-between">
            Withdrawing
            <div className="flex flex-col items-end font-semibold">
              {props.amountUSD && (
                <SpinnerContainer isLoading={props.isLoading}>
                  {totalLpBaseTokens}
                </SpinnerContainer>
              )}
            </div>
          </div>

          <div className="flex flex-col items-end text-sm">
            {props.amountUSD && (
              <SpinnerContainer isLoading={props.isLoading}>
                {baseTokenAmountBaseTokens}
              </SpinnerContainer>
            )}
          </div>
          <div className="flex flex-col items-end text-sm">
            {props.amountUSD && (
              <SpinnerContainer isLoading={props.isLoading}>
                {memberTokenAmountBaseTokens}
              </SpinnerContainer>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default WithdrawingAmounts;
